import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CustomFrameworkColumnMapping,
  CustomFrameworkIssuesData,
  CustomFrameworkIssueSeverity,
  CustomFrameworkPreview,
  CustomFrameworkValidateResponse,
  ImpactedGroupsData,
  PageParams,
  SaveCustomFrameworkPayload,
  SkillFrameworkVersionDiffData,
} from '../../entities/custom-skills-framework.model';
import { SkillFramework } from '../../entities/skills-framework.model';

export interface FrameworkVersionUploadApi {
  downloadTemplate(): Observable<void>;
  previewCustomFramework(s3Key: string): Observable<CustomFrameworkPreview>;
  validateCustomFrameworkVersion(
    skillFrameworkId: number,
    s3Key: string,
    mapping: CustomFrameworkColumnMapping,
  ): Observable<CustomFrameworkValidateResponse>;
  getUploadIssues(
    uploadId: number,
    pageData?: PageParams,
    severity?: CustomFrameworkIssueSeverity,
  ): Observable<CustomFrameworkIssuesData>;
  getVersionDiff(
    skillFrameworkId: number,
    frameworkUploadId: number,
    pageData?: PageParams,
    withImpact?: boolean,
  ): Observable<SkillFrameworkVersionDiffData>;
  getImpactedGroups(
    skillFrameworkId: number,
    skillId: number,
    pageData?: PageParams,
  ): Observable<ImpactedGroupsData>;
}

export interface FrameworkWriteApi {
  saveCustomFramework(id: number, payload: SaveCustomFrameworkPayload): Observable<SkillFramework>;
}

export interface FrameworkConfigApi {
  updateConfiguration(request: { default_skill_framework_id?: number }): Observable<unknown>;
}

export const FRAMEWORK_VERSION_UPLOAD_API = new InjectionToken<FrameworkVersionUploadApi>(
  'FRAMEWORK_VERSION_UPLOAD_API',
);

export const FRAMEWORK_WRITE_API = new InjectionToken<FrameworkWriteApi>('FRAMEWORK_WRITE_API');

export const FRAMEWORK_CONFIG_API = new InjectionToken<FrameworkConfigApi>('FRAMEWORK_CONFIG_API');
